import React, {useEffect, useState} from "react";
import {makeStyles} from "@mui/styles";
import {Box, Skeleton} from "@mui/material";
const useStyles = makeStyles( theme =>({
    widgetImageHolder:{
        position: "absolute",
        width: "auto",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        height: "100%",
        maxHeight: "100%"
    },
    widgetMainPhotoComponent:{
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    },
    viewContentWrapperPhoto:{
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
        filter: "blur(6px)"
    }
}))
const PhotoView = ({src, photo}) => {
    const [current, setCurrent] = useState(photo.id);
    const [initialized, setInitialized] = useState(false);
    const classes = useStyles();
    const [bgReady, setBgReady] = useState(false);
    useEffect(()=>{
        if( current !== photo.id){
            setCurrent(photo.id);
            window._tvpa.push(['track','pv', {
                vd: photo.id,
                li: photo.loginId
            }]);
        }
    },[src, photo])
    useEffect(() => {
        if (!initialized) {
            setInitialized(true);
            window._tvpa.push(['track', 'pv', {
                vd: photo.id,
                li: photo.loginId
            }]);
        }
    }, [src, photo])
    return <div className={classes.widgetMainPhotoComponent}>
        <div style={{ backgroundImage: `url(${src})` }}
        className={classes.viewContentWrapperPhoto} />
        <img className={classes.widgetImageHolder} src={src} onLoad={()=>setBgReady(true)} />
        { !bgReady && <Box position={"absolute"} bottom={0} right={0} top={0} left={0} paddingTop={"100%"} bgcolor={"#ffffff"}>
            <Skeleton width={"100%"} height={'100%'} sx={{position: 'absolute', top:0}} variant={'rectangular'} animation={"wave"} />
        </Box>}
    </div>
}
export default PhotoView;